export default __webpack_public_path__ + "static/media/Savant's Mantle of the Heavens.5d47c7f2.jpg";